import { render, staticRenderFns } from "./PartCategoryDropdown.vue?vue&type=template&id=98a1e928"
import script from "./PartCategoryDropdown.vue?vue&type=script&lang=ts"
export * from "./PartCategoryDropdown.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports